<template>

    <div class="com-news-list-v-cover">
        <ul>
            <li v-for="item in list" :key="item.id">
                <a :href="tplGetDetailLink(item)" target="_blank" class="flex">
                    <div class="pic cover-image" :style="tplGetStyle(item)"></div>

                    <div class="text">
                        <div class="top">{{item.title}}</div>
                        <div class="detail el">{{item.summary}}</div>

                        <div class="tag-info">
                            <span v-for="tag in item.tags" :key="tag.id" class="tag">{{tag.name}}</span>

                            <span class="author">{{item.author.name}}</span>
                            <span class="author">{{tplFormatNiceTime(item)}}</span>
                        </div>
                    </div>
                </a>

            </li>
        </ul>
    </div>

</template>

<script>
import Utils from "@/utils/utils";

export default {
    props: {
        list: {
            type: Array,
            value: []
        }
    },

    data() {
        return {}
    },

    created() {

    },

    methods: {
        tplGetStyle(item){
            return {backgroundImage: `url("${item.covers}")`}
        },

        tplGetDetailLink(item) {
            return item.link || Utils.getPageUrl('detail', {id: item.id})
        },

        tplFormatNiceTime(item) {
            return Utils.niceTime(item.publishTime);
        },
    }

}
</script>

<style lang="less" scoped>

.com-news-list-v-cover {


    .cover-image {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }


    li {
        cursor: pointer;
        font-size: 20px;
        padding: 16px 0 17px;
        border-bottom: 1px dashed #EDEDED;

        &:hover{
            .text .top{
                color: #f00;
            }
        }

        .pic {
            width: 150px;
            height: 100px;
            border-radius: 4px;
            overflow: hidden;

            img {
                transition: transform .3s;
            }
        }

        .text {
            width: 636px;
            color: #363A3E;
            margin-left: 15px;
            height: 100px;
            padding-right: 10px;
            box-sizing: border-box;

            .top {
                font-family: Helvetica;
                font-size: 20px;
                color: #363A3E;
            }

            .detail {
                color: #8B9CB7;
                margin-top: 10px;
                font-size: 14px;
                text-align: justify;
            }
        }
    }



    .tag-info{
        font-size: 14px;
        color: #8B9CB7;
        margin-top: 14px;
    }

    .tag{
        border: 1px solid rgba(139, 156, 183, 0.5);
        border-radius: 1px;
        font-size: 13px;
        color: #8B9CB7;
        height: 18px;
        line-height: 16px;
        box-sizing: border-box;
        padding: 0 4px;
        margin-right: 12px;
    }

    .author{
        margin-right: 12px;
    }

}


</style>
